import { cx } from './cx';
import s from './Stars.module.css';

/** Étoiles pleines/vides pour une note sur 5 (arrondie à l'entier le plus proche). */
export const stars = (n: number) => {
  const full = Math.max(0, Math.min(5, Math.round(n)));
  return '★'.repeat(full) + '☆'.repeat(5 - full);
};

/** Note sur 5 en étoiles ; `label` est l'équivalent accessible (ex. « 4,2 sur 5 »). */
export function Stars({ value, label, className }: { value: number; label: string; className?: string }) {
  return (
    <span className={cx(s.stars, className)} role="img" aria-label={label}>
      {stars(value)}
    </span>
  );
}
